import {
  DEFAULT_PRODUCT_CTA_TEXT,
  DEFAULT_PRODUCT_DESCRIPTION,
  DEFAULT_PRODUCT_IMAGE,
  DEFAULT_PRODUCT_NAME,
} from './constants';

export const defaultStructure = {
  type: 'doc',
  attrs: {
    id: null,
    data: {
      pageId: '2216b123-a821-4de7-b4d0-3525a9e6a39c',
    },
    pageId: 'ce3d67bd-61a0-40f6-aef7-2bc667913620',
    lp_name: '',
    deletable: true,
    appliedThemeId: null,
    backgroundColor: 'inherit',
  },
  content: [
    {
      type: 'container',
      attrs: {
        id: '9cdf955e-fc9f-4593-ab9a-da7faedfc73c',
        top: '0px',
        blur: '0px',
        left: '0px',
        right: '0px',
        width: '100%',
        bottom: '0px',
        margin: '0px 0px 0px 0px',
        shadow: 'none',
        tokens: {
          backgroundColor: 'disabled',
        },
        lp_name: 'Product Card',
        padding: '0px 0px 0px 0px',
        flexWrap: 'nowrap',
        mergeTag: null,
        overflow: 'hidden',
        position: 'relative',
        deletable: true,
        textAlign: 'center',
        width_max: '100%',
        borderColor: '#E5E7EB',
        borderStyle: 'none',
        borderWidth: '1px',
        borderRadius: '8px 8px 8px 8px',
        flexDirection: 'column',
        stackOnMobile: true,
        verticalAlign: 'align_start',
        appliedThemeId: null,
        backgroundColor: '#ffffff',
        horizontalAlign: 'left',
        backgroundDarken: false,
        centerVertically: false,
        positionTopActive: true,
        centerHorizontally: false,
        positionLeftActive: false,
        mobileFlexDirection: 'column',
        positionRightActive: true,
        positionBottomActive: false,
      },
      content: [
        {
          type: 'container',
          attrs: {
            id: '54f85acd-be18-4ab9-97be-b8e8ea335c18',
            gap: '0px',
            top: '0px',
            blur: '0px',
            left: '0px',
            right: '0px',
            width: '100%',
            bottom: '0px',
            margin: '0px 0px 0px 0px',
            shadow: 'none',
            tokens: {
              backgroundColor: 'disabled',
            },
            lp_name: '',
            padding: '0px 0px 0px 0px',
            flexWrap: 'nowrap',
            mergeTag: null,
            overflow: 'visible',
            position: 'relative',
            deletable: true,
            textAlign: 'center',
            width_max: null,
            borderColor: '#E5E7EB',
            borderStyle: 'none',
            borderWidth: '0px 0px 0px 0px',
            borderRadius: '0px 0px 0px 0px',
            flexDirection: 'column',
            stackOnMobile: true,
            verticalAlign: 'align_center',
            appliedThemeId: null,
            backgroundColor: 'transparent',
            horizontalAlign: 'left',
            backgroundDarken: false,
            centerVertically: false,
            positionTopActive: true,
            centerHorizontally: false,
            positionLeftActive: false,
            mobileFlexDirection: 'column',
            positionRightActive: true,
            positionBottomActive: false,
          },
          content: [
            {
              type: 'container',
              attrs: {
                id: '505bbfcf-5f57-4e8f-9c93-3581258e4e74',
                gap: '8px',
                top: '0px',
                blur: '0px',
                left: '0px',
                right: '0px',
                width: '100%',
                bottom: '0px',
                margin: '0px 0px 0px 0px',
                shadow: 'none',
                tokens: {
                  backgroundColor: 'disabled',
                },
                lp_name: '',
                padding: '0px',
                flexWrap: 'nowrap',
                mergeTag: null,
                overflow: 'hidden',
                position: 'relative',
                deletable: true,
                textAlign: 'center',
                width_max: '100%',
                borderColor: '#E5E7EB',
                borderStyle: 'none',
                borderWidth: '1px',
                borderRadius: '8px 8px 0px 0px',
                flexDirection: 'column',
                stackOnMobile: true,
                verticalAlign: 'align_center',
                appliedThemeId: null,
                backgroundColor: 'transparent',
                horizontalAlign: 'left',
                backgroundDarken: false,
                centerVertically: false,
                positionTopActive: true,
                centerHorizontally: false,
                positionLeftActive: false,
                mobileFlexDirection: 'column',
                positionRightActive: true,
                positionBottomActive: false,
              },
              content: [
                {
                  type: 'image',
                  attrs: {
                    id: '183ef56e-2329-44af-8fb6-57452265c48c',
                    alt: '',
                    src: DEFAULT_PRODUCT_IMAGE,
                    top: '0px',
                    url: '',
                    left: '0px',
                    align: 'center',
                    right: '0px',
                    title: '',
                    width: 990,
                    bottom: '0px',
                    height: 660,
                    target: null,
                    tokens: {},
                    lp_name: 'Image',
                    padding: '0px',
                    mergeTag: 'product.image',
                    position: 'relative',
                    boxShadow: 'none',
                    objectFit: 'cover',
                    captionUrl: 'https://unsplash.com/@farreal',
                    aspectRatio: 1.5,
                    borderColor: '#E5E7EB',
                    borderStyle: 'none',
                    borderWidth: '0px',
                    isFullWidth: true,
                    borderRadius: '0px',
                    captionAlign: 'center',
                    captionTarget: null,
                    internal_link: false,
                    appliedThemeId: null,
                    open_in_new_tab: false,
                    centerVertically: false,
                    positionTopActive: true,
                    centerHorizontally: false,
                    positionLeftActive: false,
                    positionRightActive: true,
                    positionBottomActive: false,
                  },
                },
              ],
            },
            {
              type: 'container',
              attrs: {
                id: '505bbfcf-5f59-4e8f-9c93-3581258e4e74',
                gap: '8px',
                top: '0px',
                blur: '0px',
                left: '0px',
                right: '0px',
                width: '100%',
                bottom: '0px',
                margin: '0px 0px 0px 0px',
                shadow: 'none',
                tokens: {
                  backgroundColor: 'disabled',
                },
                lp_name: '',
                padding: '8px 16px 8px 16px',
                flexWrap: 'nowrap',
                mergeTag: null,
                overflow: 'visible',
                position: 'relative',
                deletable: true,
                textAlign: 'center',
                width_max: '100%',
                borderColor: '#E5E7EB',
                borderStyle: 'none',
                borderWidth: '1px',
                borderRadius: '8px',
                flexDirection: 'column',
                stackOnMobile: true,
                verticalAlign: 'align_center',
                appliedThemeId: null,
                backgroundColor: 'transparent',
                horizontalAlign: 'left',
                backgroundDarken: false,
                centerVertically: false,
                positionTopActive: true,
                centerHorizontally: false,
                positionLeftActive: false,
                mobileFlexDirection: 'column',
                positionRightActive: true,
                positionBottomActive: false,
              },
              content: [
                {
                  type: 'columns',
                  attrs: {
                    id: '08d1099d-214f-43e5-85b6-d5db3728528b',
                    gap: '4px',
                    width: '100%',
                    layout: 'custom',
                    margin: '0px 0px 0px 0px',
                    tokens: {
                      backgroundColor: 'disabled',
                    },
                    lp_name: '',
                    padding: '0px 0px 0px 0px',
                    boxShadow: 'none',
                    deletable: true,
                    borderRadius: '0px 0px 0px 0px',
                    isFullHeight: false,
                    stackOnMobile: true,
                    appliedThemeId: null,
                    backgroundColor: 'transparent',
                    backgroundDarken: false,
                    mobile_direction: 'direction_vertical',
                    gridTemplateColumns: '70fr 30fr',
                  },
                  content: [
                    {
                      type: 'container',
                      attrs: {
                        id: 'f9cc6e8f-b9a7-49ff-a951-b1e87b67d141',
                        top: '0px',
                        blur: '0px',
                        left: '0px',
                        right: '0px',
                        width: '100%',
                        bottom: '0px',
                        margin: '0px 0px 0px 0px',
                        shadow: 'none',
                        tokens: {
                          backgroundColor: 'disabled',
                        },
                        lp_name: '',
                        padding: '0px 0px 0px 0px',
                        flexWrap: 'nowrap',
                        mergeTag: null,
                        overflow: 'visible',
                        position: 'relative',
                        deletable: true,
                        textAlign: 'center',
                        width_max: '100%',
                        borderColor: '#E5E7EB',
                        borderStyle: 'none',
                        borderWidth: '1px',
                        borderRadius: '8px',
                        flexDirection: 'column',
                        stackOnMobile: true,
                        verticalAlign: 'align_center',
                        appliedThemeId: null,
                        backgroundColor: 'transparent',
                        horizontalAlign: 'left',
                        backgroundDarken: false,
                        centerVertically: false,
                        positionTopActive: true,
                        centerHorizontally: false,
                        positionLeftActive: false,
                        mobileFlexDirection: 'column',
                        positionRightActive: true,
                        positionBottomActive: false,
                      },
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            id: 'b759db05-0443-4203-91f0-de9ef42307a9',
                            top: '0px',
                            left: '0px',
                            right: '0px',
                            width: '100%',
                            bottom: '0px',
                            tokens: {},
                            lp_name: 'Name',
                            padding: '0px 0px 0px 0px',
                            maxWidth: '100%',
                            mergeTag: 'product.name',
                            position: 'relative',
                            deletable: true,
                            textAlign: 'left',
                            lineHeight: '20px',
                            borderColor: 'inherit',
                            borderStyle: 'none',
                            borderWidth: '0px',
                            postAuthors: [],
                            postTagsGap: '4px',
                            borderRadius: '0px',
                            postPaidText: '',
                            letterSpacing: '0px',
                            textTransform: 'none',
                            aiConversation: [],
                            appliedThemeId: null,
                            lineClampClass: '',
                            postAuthorsGap: '4px',
                            backgroundColor: 'transparent',
                            centerVertically: false,
                            postPaidIconFill: '#030712',
                            positionTopActive: true,
                            postAuthorsByLine: '',
                            centerHorizontally: false,
                            positionLeftActive: false,
                            postPaidContentGap: '4px',
                            postReadTimeSuffix: 'min read',
                            positionRightActive: true,
                            positionBottomActive: false,
                            postAuthorsImageSize: '24px',
                            postTimestampDisplay: 'short_date',
                            postAuthorsImagesFill: 'inherit',
                            postAuthorsTextEnabled: true,
                            postPaidContentIconSize: 16,
                            postAuthorsImagesEnabled: true,
                            postTagsTruncateListEnabled: true,
                            postAuthorsTruncateListEnabled: false,
                          },
                          content: [
                            {
                              text: DEFAULT_PRODUCT_NAME,
                              type: 'text',
                              marks: [
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '#030712',
                                    tokens: {},
                                    fontSize: '13px',
                                    fontFamily: 'Inter',
                                    fontWeight: '600',
                                    fontGradient: null,
                                    textTransform: null,
                                    appliedThemeId: null,
                                    hoverTextColor: null,
                                    mobileFontSize: null,
                                    hoverDecorationLine: null,
                                    hoverDecorationColor: null,
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'container',
                      attrs: {
                        id: '7c1d991b-0bd0-424c-b540-a3a9acfca587',
                        top: '0px',
                        blur: '0px',
                        left: '0px',
                        right: '0px',
                        width: '100%',
                        bottom: '0px',
                        margin: '0px 0px 0px 0px',
                        shadow: 'none',
                        tokens: {
                          backgroundColor: 'disabled',
                        },
                        lp_name: '',
                        padding: '0px 0px 0px 0px',
                        flexWrap: 'nowrap',
                        mergeTag: null,
                        overflow: 'visible',
                        position: 'relative',
                        deletable: true,
                        textAlign: 'center',
                        width_max: '100%',
                        borderColor: '#E5E7EB',
                        borderStyle: 'none',
                        borderWidth: '1px',
                        borderRadius: '8px',
                        flexDirection: 'column',
                        stackOnMobile: true,
                        verticalAlign: 'align_center',
                        appliedThemeId: null,
                        backgroundColor: 'transparent',
                        horizontalAlign: 'center',
                        backgroundDarken: false,
                        centerVertically: false,
                        positionTopActive: true,
                        centerHorizontally: false,
                        positionLeftActive: false,
                        mobileFlexDirection: 'column',
                        positionRightActive: true,
                        positionBottomActive: false,
                      },
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            id: 'af68389d-d8d3-47d8-9deb-737fe54ecd6f',
                            top: '0px',
                            left: '0px',
                            right: '0px',
                            width: '100%',
                            bottom: '0px',
                            tokens: {},
                            lp_name: 'Unit amount',
                            padding: '0px 0px 0px 0px',
                            maxWidth: '100%',
                            mergeTag: 'product.unit_amount',
                            position: 'relative',
                            deletable: true,
                            textAlign: 'right',
                            lineHeight: '20px',
                            borderColor: 'inherit',
                            borderStyle: 'none',
                            borderWidth: '0px',
                            postAuthors: [],
                            postTagsGap: '4px',
                            borderRadius: '0px',
                            postPaidText: '',
                            letterSpacing: '0px',
                            textTransform: 'none',
                            aiConversation: [],
                            appliedThemeId: null,
                            lineClampClass: '',
                            postAuthorsGap: '4px',
                            backgroundColor: 'transparent',
                            centerVertically: false,
                            postPaidIconFill: '#030712',
                            positionTopActive: true,
                            postAuthorsByLine: '',
                            centerHorizontally: false,
                            positionLeftActive: false,
                            postPaidContentGap: '4px',
                            postReadTimeSuffix: 'min read',
                            positionRightActive: true,
                            positionBottomActive: false,
                            postAuthorsImageSize: '24px',
                            postTimestampDisplay: 'short_date',
                            postAuthorsImagesFill: 'inherit',
                            postAuthorsTextEnabled: true,
                            postPaidContentIconSize: 16,
                            postAuthorsImagesEnabled: true,
                            postTagsTruncateListEnabled: true,
                            postAuthorsTruncateListEnabled: false,
                          },
                          content: [
                            {
                              text: '$14.99 USD',
                              type: 'text',
                              marks: [
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '#030712',
                                    tokens: {},
                                    fontSize: '13px',
                                    fontFamily: 'Inter',
                                    fontWeight: '600',
                                    fontGradient: null,
                                    textTransform: null,
                                    appliedThemeId: null,
                                    hoverTextColor: null,
                                    mobileFontSize: null,
                                    hoverDecorationLine: null,
                                    hoverDecorationColor: null,
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'container',
                  attrs: {
                    id: '193d681e-5fb5-4d0a-886d-365514295091',
                    top: '0px',
                    blur: '0px',
                    left: '0px',
                    right: '0px',
                    width: '100%',
                    bottom: '0px',
                    margin: '0px 0px 0px 0px',
                    shadow: 'none',
                    tokens: {
                      backgroundColor: 'disabled',
                    },
                    lp_name: '',
                    padding: '0px 0px 0px 0px',
                    flexWrap: 'nowrap',
                    mergeTag: null,
                    overflow: 'visible',
                    position: 'relative',
                    deletable: true,
                    textAlign: 'center',
                    width_max: '100%',
                    borderColor: '#E5E7EB',
                    borderStyle: 'none',
                    borderWidth: '1px',
                    borderRadius: '8px',
                    flexDirection: 'column',
                    stackOnMobile: true,
                    verticalAlign: 'align_center',
                    appliedThemeId: null,
                    backgroundColor: 'transparent',
                    horizontalAlign: 'left',
                    backgroundDarken: false,
                    centerVertically: false,
                    positionTopActive: true,
                    centerHorizontally: false,
                    positionLeftActive: false,
                    mobileFlexDirection: 'column',
                    positionRightActive: true,
                    positionBottomActive: false,
                  },
                  content: [
                    {
                      type: 'paragraph',
                      attrs: {
                        id: 'b1004efe-4b7a-470f-bce2-a390fb1d52a2',
                        top: '0px',
                        left: '0px',
                        right: '0px',
                        width: '100%',
                        bottom: '0px',
                        tokens: {},
                        lp_name: 'Description',
                        padding: '0px 0px 0px 0px',
                        maxWidth: '100%',
                        mergeTag: 'product.description',
                        position: 'relative',
                        deletable: true,
                        textAlign: 'left',
                        lineHeight: '120%',
                        borderColor: 'inherit',
                        borderStyle: 'none',
                        borderWidth: '0px',
                        postAuthors: [],
                        postTagsGap: '4px',
                        borderRadius: '0px',
                        postPaidText: '',
                        letterSpacing: '0px',
                        textTransform: 'none',
                        aiConversation: [],
                        appliedThemeId: null,
                        lineClampClass: '',
                        postAuthorsGap: '4px',
                        backgroundColor: 'transparent',
                        centerVertically: false,
                        postPaidIconFill: '#030712',
                        positionTopActive: true,
                        postAuthorsByLine: '',
                        centerHorizontally: false,
                        positionLeftActive: false,
                        postPaidContentGap: '4px',
                        postReadTimeSuffix: 'min read',
                        positionRightActive: true,
                        positionBottomActive: false,
                        postAuthorsImageSize: '24px',
                        postTimestampDisplay: 'short_date',
                        postAuthorsImagesFill: 'inherit',
                        postAuthorsTextEnabled: true,
                        postPaidContentIconSize: 16,
                        postAuthorsImagesEnabled: true,
                        postTagsTruncateListEnabled: true,
                        postAuthorsTruncateListEnabled: false,
                      },
                      content: [
                        {
                          text: DEFAULT_PRODUCT_DESCRIPTION,
                          type: 'text',
                          marks: [
                            {
                              type: 'textStyle',
                              attrs: {
                                color: '#E5E7EB',
                                tokens: {
                                  color: 'border_color',
                                },
                                fontSize: '12px',
                                fontFamily: '',
                                fontWeight: '',
                                fontGradient: null,
                                textTransform: null,
                                appliedThemeId: null,
                                hoverTextColor: null,
                                mobileFontSize: null,
                                hoverDecorationLine: null,
                                hoverDecorationColor: null,
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              type: 'container',
              attrs: {
                id: '9ad6c80d-0143-467a-ad79-beaf3a168685',
                top: '0px',
                blur: '0px',
                left: '0px',
                right: '0px',
                width: '100%',
                bottom: '0px',
                margin: '0px 0px 0px 0px',
                shadow: 'none',
                tokens: {
                  backgroundColor: 'disabled',
                },
                lp_name: '',
                padding: '8px 16px 8px 16px',
                flexWrap: 'nowrap',
                mergeTag: null,
                overflow: 'visible',
                position: 'relative',
                deletable: true,
                textAlign: 'center',
                width_max: '100%',
                borderColor: '#E5E7EB',
                borderStyle: 'none',
                borderWidth: '1px',
                borderRadius: '0px 0px 0px 0px',
                flexDirection: 'column',
                stackOnMobile: true,
                verticalAlign: 'align_center',
                appliedThemeId: null,
                backgroundColor: 'transparent',
                horizontalAlign: 'center',
                backgroundDarken: false,
                centerVertically: false,
                positionTopActive: true,
                centerHorizontally: false,
                positionLeftActive: false,
                mobileFlexDirection: 'column',
                positionRightActive: true,
                positionBottomActive: false,
              },
              content: [
                {
                  type: 'button',
                  attrs: {
                    id: '362f383f-64d5-42e1-b86f-313086d05f07',
                    size: 'normal',
                    width: '100%',
                    margin: '0px',
                    tokens: {},
                    lp_name: 'Checkout button',
                    action: 'product_checkout',
                    mergeTag: 'product.cta_text',
                    onClick: 'link',
                    padding: '6px 12px 6px 12px',
                    fontSize: '12px',
                    iconSize: '24px',
                    maxWidth: '100%',
                    alignment: 'left',
                    iconColor: '#ffffff',
                    fontFamily: 'Inter',
                    borderColor: '#030712',
                    borderStyle: 'none',
                    borderWidth: '1px',
                    borderRadius: '24px 24px 24px 24px',
                    isCustomLink: false,
                    iconPlacement: 'right',
                    appliedThemeId: null,
                    customTextColor: '#ffffff',
                    open_in_new_tab: false,
                    customBackgroundColor: '#030712',
                  },
                  content: [
                    {
                      text: DEFAULT_PRODUCT_CTA_TEXT,
                      type: 'text',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
